import React from 'react';
import Review from './review';
import '../css/Service.css';

function NonHazardousWaste() {
  return (
    <div className="service-page">
      <div className="service-banner">
        <img src={'/img_5.jpg'} alt="Non-Hazardous Waste Banner" className="service-banner-img" />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Non-Hazardous Waste</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>NON-HAZARDOUS WASTE</h1>
        <p>
          Most businesses generate waste, whether non-hazardous or hazardous. Even non-hazardous material should be managed responsibly rather than disposed of in local landfills.
        </p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>Non-hazardous waste streams include:</h2>
          <ol className="feature-list">
            <li>Ash</li>
            <li>Sludges</li>
            <li>Antifreeze</li>
            <li>Grinding dusts</li>
            <li>Liquids contaminated with non-hazardous chemicals</li>
            <li>Plastic packaging</li>
            <li>Clean glass and plastic</li>
            <li>Paper and cardboard</li>
            <li>Office products</li>
            <li>Zinc plating</li>
            <li>Aluminum</li>
            <li>Copper and gold (commonly used in computer parts)</li>
            <li>Plastic and glass</li>
            <li>Coal combustion residuals</li>
            <li>Spent foundry sand</li>
            <li>Construction materials</li>
            <li>General waste</li>
            <li>And many more…</li>
          </ol>

          <p>
            We provide collection, recycling, and disposal options for a wide range of non-hazardous wastes. Our team helps you implement diversion strategies to reduce landfill impact and manage costs.
          </p>

          <div className="service-cta">
            <a href="/contact" className="btn btn-primary">Request Non-Hazardous Waste Services</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="specialty-card">
            <h3>Why partner with us?</h3>
            <ul className="specialty-list">
              <li>Responsible diversion and recycling options</li>
              <li>Efficient collection and logistics</li>
              <li>Transparent reporting and invoicing</li>
              <li>Customized programs for your operations</li>
            </ul>
          </div>
        </aside>
      </section>

      <Review />
    </div>
  );
}

export default NonHazardousWaste;
